import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import EncoderWheel from '../assets/equipment/3.21-typical-encoder-wheel-line.png';
import SkidDetect from '../assets/equipment/3.22-skid-detect-proximity-sensor.png';
import Photoeye from '../assets/equipment/3.23-part-detect-photoeye.png';
import DoorLaser from '../assets/equipment/3.24-door-open-laser-assembly.png';

import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Part Detect Skid</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Encoder Wheel Line Tracker" className="mb-3">
								<Tab eventKey="Encoder Wheel Line Tracker" title="Encoder Wheel Line Tracker">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>ENCODER WHEEL LINE TRACKER</h2>
											<p>The Encoder Wheel Line Tracker units (2) track the vehicle’s position through the Main Frame inspection cell. In the inspection area, the wheel trackers communicate to the trigger board that reads the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions.</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={EncoderWheel} alt="Master Key Box" style={{ width: '25vw', margin: '20px' }} />
												<figcaption>Figure 1: Typical Encoder Wheel Line Tracker</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="AB Skid Detect Switch Bracket" title="AB Skid Detect Switch Bracket">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>AB SKID DETECT SWITCH BRACKET</h2>
											<p>
												The roller bed skid detect switches are inductive proximity sensors mounted on the channel strut on the side of the Main Frame and Tail Gate conveyors. They send a signal to the <b>PLC</b> once it detects the presence of the part carrier skid on the conveyor.
											</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={SkidDetect} alt="Master Key Box" style={{ width: '30vw', margin: '20px' }} />
												<figcaption>Figure 1: Skid Detect Proximity Sensor Examples</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Part Detect Photoeye Assembly" title="Part Detect Photoeye Assembly">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>PART DETECT PHOTOEYE ASSEMBLY</h2>
											<p>
												This photoelectric sensor emits a light beam toward the center of the conveyor at predetermined locations. When a vehicle approaches, the beam is reflected back to its receiver and sends a signal to the <b>PLC</b> that a part is present.
											</p>
										</div>

										<div class="right-side">
											<figure>
												<img src={Photoeye} alt="Master Key Box" style={{ width: '36vw', margin: '20px' }} />
												<figcaption>Figure 1: Part Detect Photoeye</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Door Open Laser Assembly" title="Door Open Laser Assembly">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<h2>DOOR OPEN LASER ASSEMBLY</h2>
											<p>
												This Retroreflective Laser Sensor emits a light beam to a reflective target and is returned to the sensor’s receiver. If an object, in this case the vehicle door, breaks the beam, it sends a signal to the <b>PLC</b> which stops the conveyor immediately and causes a faulted condition.
											</p>

											<div class="caution">
												<p>Never stare directly into the sensor lens.</p>
												<p>Laser light can damage your eyes.</p>
												<p>Avoid placing any mirror-like object in the beam. Never use a mirror as a retroreflective target.</p>
											</div>
										</div>

										<div class="right-side">
											<figure>
												<img src={DoorLaser} alt="Master Key Box" style={{ width: '36vw', margin: '20px' }} />
												<figcaption>Figure 1: Door Open Laser Assembly</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
